import {IParams, RecursosController} from "../recursos";
import {IVideoResumen} from "services-comun-ed/modules/services/videos/interface";
import {VideoWebFrontendRequest} from "services-comun-ed/modules/services/videos/web/frontend-web";
import {EventManager} from "./event-manager";

declare global {
    interface Window {
        dailymotion: any;
        subtipologia: string;
        listaKeyValuesTexto: string;
    }
}

export class DailymotionControllerVideoSeccion extends RecursosController {

    private readonly cantidad: number = 12;
    private isLoading: boolean = false;
    private posicion: number;
    private activeVideo: string;

    /* INSTANCE */
    public static instance: DailymotionControllerVideoSeccion;

    /* STATIC */
    public static override async build(): Promise<void> {
        DailymotionControllerVideoSeccion.instance = new this();
    }

    constructor() {
        super();
        this.load();
        this.addEvents();
        this.initObserver();
        this.activeVideo = document.querySelector('.player-dm')?.getAttribute("data-uid")??'';
        this.posicion = Number(document.querySelector('.main-player')?.getAttribute('data-position'));
    }

    protected addEvents(): void {
        const videos =  document.querySelectorAll('.video-thumbnail');
        videos.forEach((video) => {
            video.addEventListener('click', this.loadEvent.bind(this));
        });
        const play =  document.querySelectorAll('.icono-miniatura');
        play.forEach((play) => {
            play.addEventListener('click', this.loadEvent.bind(this));
        });
    }

    protected async loadEvent(e:any): Promise<void> {
        const video = e.currentTarget as HTMLElement;
        const id = video.parentElement?.getAttribute('data-uid');
        if (id) {
            if (!window.hbError) {
                const eventId = "prerollKv" + id;
                const em = EventManager.build();
                em.addId(eventId);

                const listener = (e: Event) => {
                    const customEvent = e as CustomEvent;
                    if (customEvent.detail) {
                        this.loadVideo(id, customEvent.detail?.kv);
                    }
                    document.removeEventListener(eventId, listener);
                };

                document.addEventListener(eventId, listener, { once: true });

                window.alpred.hb.refreshById(["preroll"]);
            } else {
                this.loadVideo(id, "");
            }
        }
    }

    protected async load(): Promise<void> {
        const id = document.querySelector('.player-dm')?.getAttribute("data-uid");
        if (id) {
            const urls: IParams[] = [{name: "script-dailymotion-xwn8e", value: "https://geo.dailymotion.com/libs/player/xwn8e.js"}];
            const promesas = await this.initPromises(urls);

            await Promise.all(promesas).then(async()=>{
                if (!window.hbError) {
                    const eventId = "prerollKv" + id;
                    const em = EventManager.build();
                    em.addId(eventId);

                    const listener = (e: Event) => {
                        const customEvent = e as CustomEvent;
                        if (customEvent.detail) {
                            this.loadVideo(id, customEvent.detail?.kv, true);
                        }
                        document.removeEventListener(eventId, listener);
                    };

                    document.addEventListener(eventId, listener, { once: true });

                    window.alpred.hb.refreshById(["preroll"]);
                } else {
                    this.loadVideo(id, "", true);
                }
            });
        }
    }

    protected async loadVideo(id: string, kvPrebid: string, init: boolean = false): Promise<void> {
        await this.changeIcon(id);
        await this.changeTitleDescription(id);

        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });

        const config: any = {
            params: {
                customConfig: {
                    dynamiciu: "/151127700/video",
                    keyvalues: 'subtipologia='+window.subtipologia+'&position=head'+ (kvPrebid.length > 0?kvPrebid:''),
                    plcmt: 2
                }
            }
        };

        config.mute = true;
        config.player = 'xwn8e';
        config.video = id;

        if (init) {
            await window.dailymotion.createPlayer("dmain", config).catch(function(e: any) {
                console.error(e);
            });
        } else {
            const player = await window.dailymotion.getPlayer();
            if (player) {
                player.setCustomConfig(config);
                await player.loadContent({video: config.video});
            }
        }
    }

    private async changeIcon(id: string): Promise<void> {
        const active = document.querySelector(`.video[data-uid="${this.activeVideo}"]`) as HTMLElement;

        if (!active.classList.contains('init-node')) {
            const iconActive = active.querySelector('.icono-miniatura') as HTMLElement;
            iconActive.remove();
            const overlayActive = await this.getPlay();
            active.appendChild(overlayActive);

            overlayActive.addEventListener('click', this.loadEvent.bind(this));

            const playing = document.querySelector(`.video[data-uid="${id}"]`) as HTMLElement;
            const iconPlaying = playing.querySelector('.icono-miniatura') as HTMLElement;
            iconPlaying.remove();
            const overlayPlaying = await this.getPlaying();
            playing.appendChild(overlayPlaying);
        }
    }

    private async changeTitleDescription(id: string): Promise<void> {
        const active = document.querySelector(`.video[data-uid="${this.activeVideo}"]`) as HTMLElement;
        const playing = document.querySelector(`.video[data-uid="${id}"]`) as HTMLElement;

        const mainTitle = document.querySelector('.titulo-principal-video') as HTMLElement;
        const mainDescription = document.querySelector('.descripcion-principal-video') as HTMLElement;
        const mainUrl = document.querySelector('.url-principal-video') as HTMLAnchorElement;

        const titleActive = active.querySelector(".video-title") as HTMLElement;
        const descriptionActive = active.nextElementSibling as HTMLElement;

        const titlePlaying = playing.querySelector(".video-title") as HTMLElement;
        const descriptionPlaying = playing.nextElementSibling as HTMLElement;

        if (!active.classList.contains('init-node')) {
            const titulo = document.createElement('a');
            titulo.textContent = mainTitle.textContent;
            titulo.href = mainUrl.href;
            titleActive.textContent = '';
            titleActive.appendChild(titulo);
            mainTitle.textContent = titlePlaying.textContent;
            descriptionActive.textContent = mainDescription.textContent;
            mainDescription.textContent = descriptionPlaying.textContent;
            mainUrl.href = titlePlaying.querySelector('a')?.href??'';
            titlePlaying.textContent = 'En reproducción';
            descriptionPlaying.textContent = '';
        } else {
            active.classList.remove('init-node');
        }

        this.activeVideo = id;
    }

    private async getPlay(): Promise<HTMLElement> {
        const overlay = document.createElement('div');
        overlay.className = 'en-imagen center-h center-v texto-blanco boton-central boton-galeria icono-miniatura boton-play';

        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.classList.add('icono');
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('width', '24');
        svg.setAttribute('height', '24');

        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('fill-rule', 'evenodd');
        path.setAttribute('clip-rule', 'evenodd');
        path.setAttribute('fill', '#FFFFFF');
        path.setAttribute('d', `M6.51,0.83l14.4,9.6c1.49,0.87,1.58,2.95,0.26,3.97L6.51,24.17C4.91,25.1,2.9,23.95,2.9,22.1V2.9C2.9,1.05,4.91-0.1,6.51,0.83z`);

        svg.appendChild(path);

        overlay.appendChild(svg);

        return overlay;
    }

    private async getPlaying(): Promise<HTMLElement> {
        const overlay = document.createElement('div');
        overlay.classList.add('en-imagen', 'center-h', 'center-v', 'texto-blanco', 'boton-central', 'icono-miniatura', 'icono-animado');

        const svgIcono = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svgIcono.setAttribute('class', 'icono');
        svgIcono.setAttribute('viewBox', '0 0 24 24');
        svgIcono.setAttribute('width', '24');
        svgIcono.setAttribute('height', '24');

        const pathsData = [
            {
                class: 'bars',
                d: 'M10.731 17.46H6.923V5.515h3.808V25.46Zm6.347 0H13.27V.987h3.808v8.473Zm-16.502 0h3.808v-7.084H.576v5.084Zm22.85 0h-3.809V13.598h3.808V17.46Z',
                clipRule: 'evenodd',
                fill: '#fff',
                fillRule: 'evenodd',
                style: 'visibility: hidden;'
            },
            {
                class: 'bars',
                d: 'M10.731 17.46H6.923V15h3.808V5.46Zm6.347 0H13.27V7.987h3.808v8.473Zm-16.502 0h3.808v-15.084H.576v.084Zm22.85 0h-3.809V4.598h3.808V17.46Z',
                fill: '#fff',
                fillRule: 'evenodd',
                clipRule: 'evenodd',
                style: 'visibility: hidden;'
            },
            {
                class: 'bars',
                d: 'M10.731 17.46H6.923V1h3.808V2.46Zm6.347 0H13.27V12.987h3.808v8.473Zm-16.502 0h3.808v-14.084H.576v.084Zm22.85 0h-3.809V5.598h3.808V17.46Z',
                fill: '#fff',
                fillRule: 'evenodd',
                clipRule: 'evenodd',
                style: 'visibility: hidden;'
            },
            {
                class: 'bars',
                d: 'M10.731 17.46H6.923V.515h3.808V17.46Zm6.347 0H13.27V8.987h3.808v8.473Zm-16.502 0h3.808v-5.084H.576v5.084Zm22.85 0h-3.809V5.598h3.808V17.46Z',
                clipRule: 'evenodd',
                fillRule: 'evenodd',
                fill: '#fff',
                style: ''
            }
        ];

        pathsData.forEach((pathData) => {
            const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            Object.entries(pathData).forEach(([key, value]) => {
                path.setAttribute(key, value);
            });
            svgIcono.appendChild(path);
        });

        overlay.appendChild(svgIcono);

        return overlay;
    }

    protected async getResources(html: HTMLElement): Promise<void> {
        //
    }

    private async initObserver(): Promise<void> {
        const observer = new IntersectionObserver(async (entries: any, observer: any) => {
            const sentinel = entries[0];
            if (sentinel.isIntersecting && !this.isLoading) {
                this.isLoading = true;
                await VideoWebFrontendRequest.getVideos(this.posicion).then((videos) => {
                    this.posicion += videos.length;
                    this.appendVideos(videos);
                    if (videos.length < this.cantidad) observer.unobserve(sentinel.target);
                }).catch((err: any) => {
                   console.error(err);
                });
                this.isLoading = false;
            }
        }, {
            rootMargin: '0px 0px 200px 0px',
            threshold: 0.5
        });
        const sentinel = document.querySelector('.sentinel') as HTMLElement;
        observer.observe(sentinel);
    }

    protected async appendVideos(videos: IVideoResumen[]): Promise<void> {
        const videoList = document.querySelector('.video-grid') as HTMLElement;
        for (const video of videos) {
            const videoCard = document.createElement('div');
            videoCard.className = 'video-card';

            const figure = document.createElement('figure');
            figure.className = 'caja-imagen video';
            figure.setAttribute('data-uid', video.uid);

            const img = document.createElement('img');
            img.className = 'video-thumbnail';
            img.src = video.cover;
            img.alt = video.title;
            img.setAttribute('loading', 'lazy');

            const overlay = await this.getPlay();

            const contenedorTitulo = document.createElement('div');
            contenedorTitulo.className = 'contenedor-title sep-bicolor sep-superior';

            const titulo = document.createElement('div');
            titulo.className = 'video-title';

            contenedorTitulo.appendChild(titulo);

            const link = document.createElement('a');
            link.href = video.url;
            link.textContent = video.title;

            titulo.appendChild(link);

            figure.appendChild(img);
            figure.appendChild(overlay);
            figure.appendChild(contenedorTitulo);

            const descripcion = document.createElement('div');
            descripcion.textContent = video.description;
            descripcion.className = 'descripcion oculto';

            videoCard.appendChild(figure);
            videoCard.appendChild(descripcion);

            figure.addEventListener('click', async (e) => {
                const video = e.currentTarget as HTMLElement;
                const id = video?.getAttribute('data-uid');
                if (id) {
                    if (!window.hbError) {
                        const eventId = "prerollKv" + id;
                        const em = EventManager.build();
                        em.addId(eventId);

                        const listener = (e: Event) => {
                            const customEvent = e as CustomEvent;
                            if (customEvent.detail) {
                                this.loadVideo(id, customEvent.detail?.kv);
                            }
                            document.removeEventListener(eventId, listener);
                        };

                        document.addEventListener(eventId, listener, { once: true });

                        window.alpred.hb.refreshById(["preroll"]);
                    } else {
                        this.loadVideo(id, "");
                    }
                }
            });

            videoList.appendChild(videoCard);
        }
    }

}
